import { Spacing } from '@vkontakte/vkui';
import classNames from 'clsx';
import React, { FC, memo, ReactElement } from 'react';
import { Hint } from 'reactApp/ui/Hint/Hint';
import { ISpaceLabel } from 'reactApp/ui/Space/SingleSpace/SingleSpaceProgress/SingleSpaceProgress.types';
import { useSpace } from 'reactApp/ui/Space/SingleSpace/SingleSpaceProgress/useSpace';
import { noopVoid } from 'reactApp/utils/helpers';

import styles from './SingleSpaceProgress.css';

const SpaceLabel: FC<ISpaceLabel & { clickable: boolean }> = ({
    text,
    id,
    hintText,
    isOverquota,
    clickable,
    onClick = noopVoid,
}): ReactElement => {
    return (
        <div className={styles.infoBlock}>
            <Hint text={hintText}>
                <div
                    className={classNames(styles.info, {
                        [styles.info_clickable]: clickable,
                    })}
                    onClick={onClick}
                >
                    <div
                        className={classNames(styles.infoLine, styles[`line_${id}`], {
                            [styles.lineFilled_overquota]: isOverquota,
                        })}
                    />
                    <div className={styles.label}>{text}</div>
                </div>
            </Hint>
        </div>
    );
};

export const SingleSpaceProgress = memo(({ isMobile = false }: { isMobile: boolean }): ReactElement => {
    const { isOverquota, spaceList, freeSpaceText, usedPercents } = useSpace();

    return (
        <>
            <div
                className={classNames(styles.line, {
                    [styles.line_overquota]: isOverquota,
                })}
            >
                <div style={{ width: `${usedPercents}%` }}>
                    {spaceList.map(({ id, percents, isOverquota, hintText, onClick = noopVoid }) => (
                        <Hint text={hintText} key={id}>
                            <div
                                className={classNames(styles.lineFilled, styles[`line_${id}`], {
                                    [styles.lineFilled_overquota]: isOverquota,
                                })}
                                style={{ width: `${percents}%` }}
                                onClick={onClick}
                            />
                        </Hint>
                    ))}
                </div>
                <Hint text={freeSpaceText}>
                    <div className={styles.lineEmpty} />
                </Hint>
            </div>

            <Spacing size={12} />
            <div
                className={classNames(styles.quotaInfo, {
                    [styles.quotaInfo_mobile]: isMobile,
                })}
            >
                {spaceList.map((item) => (
                    <SpaceLabel
                        id={item.id}
                        key={item.id}
                        isOverquota={item.isOverquota}
                        text={item.text}
                        hintText={item.hintText}
                        onClick={item?.onClick}
                        clickable={Boolean(item?.onClick)}
                    />
                ))}
            </div>
        </>
    );
});

SingleSpaceProgress.displayName = 'SingleSpaceProgress';
